const charsOkInComponent = ['(',')','~',',','.',':','_','/']
const charsOkInUrl = ['?','=','&', ...charsOkInComponent]

module.exports = {
    charsOkInComponent,
    charsOkInUrl,
}